import { CalendarDots, Confetti, ForkKnife } from '@phosphor-icons/react';

export const CATEGORIES = {
  dining: { label: 'Food & Drink', Icon: ForkKnife, tone: '#f05a47' },
  entertainment: { label: 'Entertainment', Icon: Confetti, tone: '#7067cf' },
  event: { label: 'Event', Icon: CalendarDots, tone: '#168aad' },
};
